import * as React from "react";
import { Link } from "react-router-dom";

export interface LinkProps {
  formFieldDefinition: any; 
  initialValues : any;
}

export const InternalLink = (props: LinkProps) => {
  if (!!props.formFieldDefinition.isDataField) {
    if (props.initialValues && props.initialValues[props.formFieldDefinition.name]) {
      return <a target="_blank" 
          href={props.initialValues[props.formFieldDefinition.name]}
          className={props.formFieldDefinition.cssClass !== undefined ? props.formFieldDefinition.cssClass : ""}
        >{props.formFieldDefinition.label}</a>;
    } else {
      return <></>;
    }
  } else
  if (props.formFieldDefinition.url.indexOf("http") == 0) {
    return <a href={props.formFieldDefinition.url}
      className={props.formFieldDefinition.cssClass !== undefined ? props.formFieldDefinition.cssClass : ""}
    >{props.formFieldDefinition.label}</a>;
  }
  return <Link to={props.formFieldDefinition.url}
      className={props.formFieldDefinition.cssClass !== undefined ? props.formFieldDefinition.cssClass : ""}
    >{props.formFieldDefinition.label}</Link>;
};